import {makeStyles} from "@material-ui/core";
import {useDispatch, useSelector} from "react-redux";
import {useEffect} from "react";
import {moveNextPage, updateCreatorOnboarding} from "../../../../../store/actions/creator/creatorOnBoarding";
import UtilService from "../../../../../helper/service";
import {useHistory, useLocation} from "react-router";
import OnboardingBtn from "../../../../atoms/creator/onboardingEnterBtn";

const useStyles = makeStyles(() => ({
  title: {
    textAlign: 'center',
    fontSize: 36,
    color: '#212D40',
    fontFamily: 'Spartan-bold',
    lineHeight: 1.25,
    marginTop: 10,
    marginBottom: 10,
    '@media (max-width: 600px)': {
      fontSize: '25px!important',
      marginTop: 26,
    },
  },
  descriptionTitle: {
    fontFamily: 'roboto-light',
    fontSize: 30,
    color: '#212D40',
    lineHeight: 1.25,
    '& span': {
      fontFamily: 'roboto-bold'
    },
    '@media (max-width: 600px)': {
      fontSize: 22,
    },
  },
  description: {
    fontFamily: 'roboto-light',
    fontSize: 14,
    color: '#212D40'
  },
  imgDiv: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    '@media (max-width: 600px)': {
      marginTop: 12,
      width: 'calc(100% - 0px)'
    },
  },
  img: {
    height: (props: any) => (props.width < 1560 || props.height < 770) ? 400 : 500,
    width: 'auto',
    '@media (max-width: 600px)': {
      width: 'calc(100% - 0px)'
    },
  },
  descriptionDiv: {
    paddingTop: (props: any) => props.height < 770 ? 30 : 100
  },
  mainDiv: {
    display: 'flex',
    marginBottom: (props: any) => props.height < 770 ? -20 : 0,
    '@media (max-width: 600px)': {
      flexDirection: 'column'
    },
  },
  descriptionMainDiv: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  }
}));

const Module1Slide5 = () => {

  const size = UtilService.useWindowSize();
  const classes = useStyles(size);
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const { userPreferences } = useSelector((state: any) => state.creatorOnBoarding);
  const { activepage } = userPreferences;
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";

  useEffect(() => {
    window.addEventListener('keydown', handleUserKeyPress);
    return () => {
      window.removeEventListener('keydown', handleUserKeyPress);
    };
  });

  useEffect(() => {
    UtilService.addHashTag(history, location.pathname, 'm1s5');
  }, []);

  const handleUserKeyPress = (event: any) => {
    if (event.keyCode === 13) {
      goNext();
    }
  };

  const goNext = () => {
    const request = {
      user_id: loginUserData.user_id,
      preference_id: userPreferences.module1s5.id,
      preference_name: 'MODULE1S5',
      preference_information: 'true',
    };
    dispatch(updateCreatorOnboarding(apolloClient.client, request));

    if (Number(activepage.value) < 7) {
      const reqActivePage = {
        user_id: loginUserData.user_id,
        preference_id: userPreferences.activepage.id,
        preference_name: 'ACTIVEPAGE',
        preference_information: '7',
      };
      dispatch(updateCreatorOnboarding(apolloClient.client, reqActivePage));
    }

    dispatch(moveNextPage(7))
  };

  const goBack = () => {
    dispatch(moveNextPage(5))
  };

  return (
    <div>
      <div className={classes.title}>
        Participation is fun, easy, and anonymous
      </div>

      <div className={classes.mainDiv}>
        <div className={classes.descriptionMainDiv}>
          <div>
            <div className={classes.descriptionTitle}>
              Connecting <br />
              is <span>simple</span>
            </div>
            <div className={classes.description}>
              Participants just download our phone app, connect a <br />
              smartwatch or fitness sensor, and turn data collection on.
            </div>
          </div>
          <div className={classes.descriptionDiv}>
            <div className={classes.descriptionTitle}>
              Results <br />
              are <span>anonymous</span>
            </div>
            <div className={classes.description}>
              We take privacy seriously. No biometric data or Immersion <br />
              results can be tied back to an individual unless they opt-in.
            </div>
          </div>
          <div className={classes.descriptionDiv}>
            <div className={classes.descriptionTitle}>
              Participants get <br />
              <span>interesting</span> insights too
            </div>
            <div className={classes.description}>
              After measurement, participants can also see their results <br />
              and learn interesting things about what turns their brain on.
            </div>
          </div>
        </div>
        <div className={classes.imgDiv}>
          <img className={classes.img} src={'/assets/icons/onboarding/module1-slide5.gif'} alt={'Turning Data'}/>
        </div>
      </div>

      <OnboardingBtn goNext={goNext} goBack={goBack} title={'Got It'} isRight/>
    </div>
  )
};

export default Module1Slide5;